import axios from "axios";

// const baseUrl = "http://localhost:3000/";
const baseUrl = "https://zgharta-app-be.vercel.app/";
const instance = axios.create({
  maxContentLength: 5000,
  maxBodyLength: 5000,
});

///////////////////////////////////** SPORTS **//////////////////////////////////////////

//Create
export async function createSport(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(baseUrl + "Ryada/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Get All
export async function getAllSports() {
  try {
    const response = await instance
      .get(baseUrl + "Ryada/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
  }
}

//Get One
export async function getSport(id) {
  try {
    const response = await axios.get(baseUrl + `Ryada/${id}`);
    return response;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Update
export async function updateSport(itemId, title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `Ryada/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating data:", error);
    throw error;
  }
}

//Restore
export async function restoreSport(itemId) {
  try {
    await axios.post(baseUrl + "Ryada/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deleteSport(itemId) {
  try {
    await axios.post(baseUrl + "Ryada/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

///////////////////////////////////** HEALTH **//////////////////////////////////////////

//Get All
export async function getAllHealth() {
  try {
    const response = await instance
      .get(baseUrl + "sohha/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
  }
}

//Create
export async function createHealth(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(baseUrl + "sohha/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Update
export async function updateHealth(itemId, title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `sohha/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Get One
export async function getHealth(id) {
  try {
    const response = await axios.get(baseUrl + `sohha/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}
//Restore
export async function restoreHealth(itemId) {
  try {
    await axios.post(baseUrl + "sohha/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deleteHealth(itemId) {
  try {
    await axios.post(baseUrl + "sohha/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

///////////////////////////////////** DEATH **//////////////////////////////////////////

//Get All
export async function getAllDeath() {
  try {
    const response = await instance
      .get(baseUrl + "wafyat/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Create
export async function createDeath(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(baseUrl + "wafyat/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Get One
export async function getDeath(id) {
  try {
    const response = await axios.get(baseUrl + `wafyat/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

//Update
export async function updateDeath(itemId, title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `wafyat/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Restore
export async function restoreDeath(itemId) {
  try {
    await axios.post(baseUrl + "wafyat/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deleteDeath(itemId) {
  try {
    await axios.post(baseUrl + "wafyat/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

///////////////////////////////////** PARISH NEWS **//////////////////////////////////////////

//Get All
export async function getAllParishNews() {
  try {
    const response = await instance
      .get(baseUrl + "AkhbarRaiiya/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Create
export async function createParishNews(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + "AkhbarRaiiya/create",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Get One
export async function getParishNews(id) {
  try {
    const response = await axios.get(baseUrl + `AkhbarRaiiya/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

//Update
export async function updateParishNews(itemId, title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `AkhbarRaiiya/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Restore
export async function restoreParishNews(itemId) {
  try {
    await axios.post(baseUrl + "AkhbarRaiiya/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deleteParishNews(itemId) {
  try {
    await axios.post(baseUrl + "AkhbarRaiiya/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

///////////////////////////////////** CHURCH NEWS **//////////////////////////////////////////

//Get All
export async function getAllChurchNews() {
  try {
    const response = await instance
      .get(baseUrl + "AkhbarKanisa/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Create
export async function createChurchNews(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + "AkhbarKanisa/create",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Get One
export async function getChurchNews(id) {
  try {
    const response = await axios.get(baseUrl + `AkhbarKanisa/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

//Update
export async function updateChurchNews(itemId, title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `AkhbarKanisa/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Restore
export async function restoreChurchNews(itemId) {
  try {
    await axios.post(baseUrl + "AkhbarKanisa/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deleteChurchNews(itemId) {
  try {
    await axios.post(baseUrl + "AkhbarKanisa/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

///////////////////////////////////** Miscellaneous NEWS **//////////////////////////////////////////

//Get All
export async function getAllMiscellaneousNews() {
  try {
    const response = await instance
      .get(baseUrl + "AkhbarMoutafarika/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Create
export async function createMiscellaneousNews(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + "AkhbarMoutafarika/create",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Get One
export async function getMiscellaneousNews(id) {
  try {
    const response = await axios.get(baseUrl + `AkhbarMoutafarika/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

//Update
export async function updateMiscellaneousNews(
  itemId,
  title,
  description,
  image
) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `AkhbarMoutafarika/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Restore
export async function restoreMiscellaneousNews(itemId) {
  try {
    await axios.post(baseUrl + "AkhbarMoutafarika/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deleteMiscellaneousNews(itemId) {
  try {
    await axios.post(baseUrl + "AkhbarMoutafarika/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

///////////////////////////////////** PASTORAL ACTIVITIES**//////////////////////////////////////////

//Get All
export async function getAllPastoralActivities() {
  try {
    const response = await instance
      .get(baseUrl + "NachatatRaawya/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Create
export async function createPastoralActivity(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + "NachatatRaawya/create",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Get One
export async function getPastoralActivity(id) {
  try {
    const response = await axios.get(baseUrl + `NachatatRaawya/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

//Update
export async function updatePastoralActivity(
  itemId,
  title,
  description,
  image
) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `NachatatRaawya/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Restore
export async function restorePastoralActivity(itemId) {
  try {
    await axios.post(baseUrl + "NachatatRaawya/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deletePastoralActivity(itemId) {
  try {
    await axios.post(baseUrl + "NachatatRaawya/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

///////////////////////////////////** OPINION AND THOUGHTS**//////////////////////////////////////////

//Get All
export async function getAllOpinionThoughts() {
  try {
    const response = await instance
      .get(baseUrl + "RaiiWFeker/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Create
export async function createOpinionThoughts(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(baseUrl + "RaiiWFeker/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Get One
export async function getOpinionThoughts(id) {
  try {
    const response = await axios.get(baseUrl + `RaiiWFeker/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

//Update
export async function updateOpinionThoughts(itemId, title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `RaiiWFeker/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Restore
export async function restoreOpinionThoughts(itemId) {
  try {
    await axios.post(baseUrl + "RaiiWFeker/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deleteOpinionThoughts(itemId) {
  try {
    await axios.post(baseUrl + "RaiiWFeker/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

///////////////////////////////////** READINGS **//////////////////////////////////////////

//Get All
export async function getAllReadings() {
  try {
    const response = await instance
      .get(baseUrl + "KiraatLyom/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Create
export async function createReading(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(baseUrl + "KiraatLyom/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Get One
export async function getReading(id) {
  try {
    const response = await axios.get(baseUrl + `KiraatLyom/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

//Update
export async function updateReading(itemId, title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `KiraatLyom/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Restore
export async function restoreReading(itemId) {
  try {
    await axios.post(baseUrl + "KiraatLyom/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deleteReading(itemId) {
  try {
    await axios.post(baseUrl + "KiraatLyom/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

///////////////////////////////////** HSTORY **//////////////////////////////////////////

//Get All
export async function getAllHistory() {
  try {
    const response = await instance
      .get(baseUrl + "Tarikh/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Create
export async function createHistory(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(baseUrl + "Tarikh/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Get One
export async function getHistory(id) {
  try {
    const response = await axios.get(baseUrl + `Tarikh/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

//Update
export async function updateHistory(itemId, title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `Tarikh/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Restore
export async function restoreHistory(itemId) {
  try {
    await axios.post(baseUrl + "Tarikh/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deleteHistory(itemId) {
  try {
    await axios.post(baseUrl + "Tarikh/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

///////////////////////////////////** SAINT **//////////////////////////////////////////

//Get All
export async function getAllSaint() {
  try {
    const response = await instance
      .get(baseUrl + "kidisallyom/all")
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Create
export async function createSaint(title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + "kidisallyom/create",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
}

//Get One
export async function getSaint(id) {
  try {
    const response = await axios.get(baseUrl + `kidisallyom/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

//Update
export async function updateSaint(itemId, title, description, image) {
  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);

    const response = await axios.post(
      baseUrl + `kidisallyom/update/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Restore
export async function restoreSaint(itemId) {
  try {
    await axios.post(baseUrl + "kidisallyom/restore", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}

//Delete
export async function deleteSaint(itemId) {
  try {
    await axios.post(baseUrl + "kidisallyom/delete", {
      id: itemId,
    });
  } catch (error) {
    throw error;
  }
}
